import Util from "../../modules/Util";

export default {
  data() {
    return {

    }
  },
  methods : {
    number_format(number, decimals, dec_point, thousands_sep) {
      return Util.number_format(number, decimals, dec_point, thousands_sep)
    },
    format_price(price, return_arr = false) {
      return Util.format_price(price, return_arr)
    },
    plural(n, forms) {
      return Util.plural(n, forms)
    },
  }
}
